export const SERVER_URL = 'http://121.40.26.104';
